<template>
  <div>
    <div class="d-flex align-center justify-space-between">
      <v-tooltip :text="nameUr">
        <template #activator="{ props }">
          <h4 style="width: 55%" class="hide-text" v-bind="props">
            {{ nameUr }}
          </h4>
        </template>
      </v-tooltip>
      <div class="d-flex align-center gap-2">
        <v-btn
          v-if="debtorData.status === 'Found'"
          variant="flat"
          color="green"
          rounded="xs"
          :loading="generatePDFHandlerLoader"
          @click="generatePDFHandler">
          Завантажити звіт
        </v-btn>
        <v-btn-toggle
          v-model="crVersion"
          mandatory
          color="black"
          variant="flat"
          density="compact"
          style="outline: 1px solid"
          @update:model-value="updateCrVersion">
          <v-btn size="small" density="comfortable" value="cr-version-1">
            CR v.1
          </v-btn>
          <v-btn size="small" density="comfortable" value="cr-version-2">
            CR v.2
          </v-btn>
        </v-btn-toggle>
      </div>
    </div>
    <div>
      <span class="text-disabled">
        <strong class="text-green">Увага!</strong> У разі виникнення питань щодо
        змісту інформації - звертайтесь до банку-кредитора.
      </span>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  emits: ['updateCrVersion', 'generatePDFEmit'],
  props: {
    nameUr: {
      type: String,
      required: true,
    },
    debtorData: { type: Object },
    generatePDFEmit: Function,
  },
  setup(props, { emit }) {
    const generatePDFHandlerLoader = ref(false)
    const crVersion = ref('cr-version-1')

    const updateCrVersion = val => {
      console.log('updateCrVersion', val)
      emit('updateCrVersion', val)
    }

    const generatePDFHandler = () => {
      generatePDFHandlerLoader.value = true

      setTimeout(() => {
        props.generatePDFEmit(true)
        generatePDFHandlerLoader.value = false
      }, 1500)
    }

    return {
      crVersion,
      updateCrVersion,
      generatePDFHandler,
      generatePDFHandlerLoader,
    }
  },
}
</script>

<style scoped lang="scss"></style>
